import type { EventName } from "@lit/react";
import { SplitLayout as SplitLayoutElement, type SplitLayoutEventMap as _SplitLayoutEventMap, } from "@vaadin/split-layout/vaadin-split-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SplitLayoutElement, };
export type SplitLayoutEventMap = Readonly<{
    onSplitterDragend: EventName<_SplitLayoutEventMap["splitter-dragend"]>;
}>;
const events = { onSplitterDragend: "splitter-dragend" } as SplitLayoutEventMap;
export type SplitLayoutProps = WebComponentProps<SplitLayoutElement, SplitLayoutEventMap>;
export const SplitLayout = createComponent({
    elementClass: SplitLayoutElement, events, react: React, tagName: "vaadin-split-layout"
});
